export const enum DataLayerEventName {
    // Ad Events
    adClick = 'ad.click',
    adEnd = 'ad.end',
    adError = 'ad.error',
    adLoad = 'ad.load',
    adMilestone25 = 'ad.milestone.25',
    adMilestone50 = 'ad.milestone.50',
    adMilestone75 = 'ad.milestone.75',
    adPause = 'ad.pause',
    adPlay = 'ad.play',
    adPodComplete = 'ads-allpods-completed',
    adRequest = 'ad.request',
    adStart = 'ad.start',
    adunitLoaded = 'adunit.loaded',
    adunitViewable = 'adunit.viewable',
    adVolumeChange = 'ad.volumechange',
    bonsaiTruskinRendered = 'adunit.bonsai-truskin.rendered',

    // Auth Events
    authLogin = 'auth.login',
    authLoginRefresh = 'auth.loginRefresh',
    authLogout = 'auth.logout',
    authNetworkError = 'auth.networkError',
    authSessionExpired = 'auth.sessionExpired',

    // Comment Events
    commentsAvailable = 'comments.available',
    commentPost = 'comment.post',
    commentReplied = 'comment.replied',
    commentEdit = 'comment.edit',
    commentReact = 'comment.react',
    commentReport = 'comment.report',
    commentLoadMore = 'comment.loadmore',
    commentIgnore = 'comment.ignore',
    commentError = 'comment.error',

    // Cookie Events
    cookieConsent = 'cookie.consent',

    // Gallery Events
    galleryLoadMore = 'gallery.load-more',
    galleryThumbnailClick = 'gallery.thumbnail.click',
    galleryThumbnailsHide = 'gallery.thumbnails.hide',
    galleryThumbnailsShow = 'gallery.thumbnails.show',

    // Nav Events
    navAvailable = 'nav.available',
    navHidden = 'nav.hidden',
    navClicked = 'nav.clicked',
    navSubNavClosed = 'nav.subNav.closed',
    navSubNavOpened = 'nav.subNav.opened',
    navFocused = 'nav.focused',

    // Newsletter Events
    newsletterSignupAvailable = 'newsletterSignup.available',
    newsletterSignupFail = 'newsletterSignup.fail',
    newsletterSignupInteract = 'newsletterSignup.interact',
    newsletterSignupSuccess = 'newsletterSignup.success',

    // Player Events
    playerError = 'player.error',
    playbackError = 'player.playback.error',
    playToPauseError = 'player.playToPause.error',
    playerFullscreenEnter = 'player.fullscreen.enter',
    playerFullscreenExit = 'player.fullscreen.exit',
    playerReady = 'player.ready',
    playerUserActive = 'player.user.active',
    playerUserInactive = 'player.user.inactive',
    playlistScroll = 'playlist.scroll',
    playlistSelect = 'playlist.select',

    // Radio Events
    radioAvailable = 'radio.available',
    radioPlay = 'radio.play',
    radioStop = 'radio.stop',
    radio30 = 'radio.30',
    radioEnd = 'radio.end',

    // Page Events
    shareButtonClick = 'shareButton.click',
    spaInitialised = 'spa.initialised',
    syntheticPageCompleted = 'syntheticPage.completed',
    syntheticPageInitiated = 'syntheticPage.initiated',
    syntheticPageError = 'syntheticPage.error',

    // Video Events
    videoAvailable = 'video.available',
    videoEnd = 'video.end',
    videoMilestone25 = 'video.milestone.25',
    videoMilestone50 = 'video.milestone.50',
    videoMilestone75 = 'video.milestone.75',
    videoPlay = 'video.play',
    videoStart = 'video.start',
    videoPause = 'video.pause',
    videoStickyOff = 'video.sticky.off',
    videoStickyOn = 'video.sticky.on',
    videoVolumeChange = 'video.volumechange',

    // Subscribe Events
    subscribeClick = 'subscribe.click',
    subscribeComplete = 'subscribe.complete',
    subscriberDropdown = 'subscriberDropdown.click',
    viewabilityBandViewed = 'viewability.band.viewed',
    extendedAccess = 'extended-access.event',
    subscribeWithGoogle = 'subscribe-with-google.event',
    viewItemListEvent = 'view_item_list',
    selectItemEvent = 'select_item',
    addToCart = 'add_to_cart',
    removeFromCart = 'remove_from_cart',
    viewSubscriptionItemListEvent = 'view_subscription_item_list',
    viewItemList = 'view_item_list',
    oddsLinkPressed = 'odds_link_pressed',
    viewCart = 'view_cart',
    breachScreenAvailable = 'breachscreen.available',
    breachScreenClick = 'breachscreen.click',
    breachScreenComplete = 'breachscreen.complete',
    billingPeriodChange = 'billing_period_change',

    // Live Blog Events
    loadMoreOlderPosts = 'live-blog-load-more-older-posts.submit',
    milestoneClick = 'live-blog-milestone.click',

    // Article Events
    webStoryCarouselViewed = 'web-story-carousel.viewed',
    webStoryClicked = 'web-story.click',
    genericArticleBannerViewed = 'generic-article-banner.viewed',
    articleAvailable = 'view_item',
    subscriptionPromptCheckout = 'subscription_prompt_checkout',
    cardClicked = 'card.clicked',
    collectionAvailable = 'collection.available',
    linkClicked = 'link.clicked',

    // GA4 Events
    ga4VideoComplete = 'video_complete',
    ga4VideoProgress = 'video_progress',
    ga4VideoPlay = 'video_play',
    ga4VideoPause = 'video_pause',
    ga4AdPlay = 'ad_play',
    ga4AdComplete = 'ad_complete',

    // Search Events
    search = 'search',
    searchFilter = 'search_filter',
    searchResults = 'search_results',

    // Saved Articles Events
    savedArticlesResults = 'saved_articles_results',
    savedArticlesSave = 'saved_articles_save',
    savedArticlesUnsave = 'saved_articles_unsave',
    savedArticlesFilter = 'saved_articles_filter',

    // Survey Events
    surveyBannerViewed = 'survey_banner.viewed',
    surveyBannerLinkClick = 'survey_banner.link_clicked',
    surveyBannerDismissed = 'survey_banner.dismissed',

    // Notification Centre Events
    notificationCentreOpened = 'notification_centre.opened',
    notificationCentreClosed = 'notification_centre.closed',

    // Embed Events
    embedViewed = 'embed.viewed',
    embedClicked = 'embed.link_clicked',

    // Custom Events
    bandViewable = 'band-viewable',
    countdownInactivityFinished = 'countdowninactivity.finished',
    inlineArticleBannerAvailable = 'inlineArticleBanner.available',
    pollieRatingSubmit = 'pollie-rater.submit',
    moreButtonClick = 'more_button',
    scrollToTop = 'scroll.to_top',
    showMoreToggle = 'show_more.toggled',
}
